import type { SVGProps } from 'react';
const SvgLockClosed = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} fill="none" viewBox="0 0 16 16" {...props}>
    <path
      fill="currentColor"
      d="M8 1.6a4 4 0 0 1 4 4v1.6c.883 0 1.6.717 1.6 1.6v4a1.6 1.6 0 0 1-1.6 1.6H4a1.6 1.6 0 0 1-1.6-1.6v-4A1.6 1.6 0 0 1 4 7.2V5.6a4 4 0 0 1 4-4m0 1.6a2.4 2.4 0 0 0-2.4 2.4v1.6h4.8V5.6A2.4 2.4 0 0 0 8 3.2"
    />
    <path
      stroke="currentColor"
      d="M8 1.6a4 4 0 0 1 4 4v1.6c.883 0 1.6.717 1.6 1.6v4a1.6 1.6 0 0 1-1.6 1.6H4a1.6 1.6 0 0 1-1.6-1.6v-4A1.6 1.6 0 0 1 4 7.2V5.6a4 4 0 0 1 4-4Zm0 1.6a2.4 2.4 0 0 0-2.4 2.4v1.6h4.8V5.6A2.4 2.4 0 0 0 8 3.2Z"
    />
  </svg>
);
export default SvgLockClosed;
